import DashboardIcon from "../assets/Icons/SidebarNew/dashboard.svg";
import DashboardWhite from "../assets/Icons/SidebarNew/dashboardWhite.svg";
import Analytics from "../assets/Icons/SidebarNew/analytics.svg";
import AnalyticsWhite from "../assets/Icons/SidebarNew/analyticsWhite.svg";
import Subscription from "../assets/Icons/SidebarNew/subscription.svg";
import SubscriptionWhite from "../assets/Icons/SidebarNew/subscriptionwhite.svg";
import Album from "../assets/Icons/SidebarNew/album.svg";
import AlbumWhite from "../assets/Icons/SidebarNew/albumWhite.svg";
import Member from "../assets/Icons/SidebarNew/members.svg";
import MemberWhite from "../assets/Icons/SidebarNew/membersWhite.svg";
import PackagePNG from "../assets/Icons/SidebarNew/package.svg";
import PackageWhite from "../assets/Icons/SidebarNew/packageWhite.svg";
import Calander from "../assets/Icons/SidebarNew/calendarEvent.svg";
import CalenderWhite from "../assets/Icons/SidebarNew/calendarEventWhite.svg";
import Packagerequest from '../assets/Icons/SidebarNew/packageRequest.svg'
import PackagerequestWhite from '../assets/Icons/SidebarNew/packageRequestWhite.svg'
import CustomerEvent from "../assets/Icons/SidebarNew/customer_events.svg";
import CustomerEventWhite from "../assets/Icons/SidebarNew/customer_eventsWhite.svg";
import Transaction from "../assets/Icons/SidebarNew/transaction.svg";
import TransactionWhite from "../assets/Icons/SidebarNew/transactionWhite.svg";
import QuotationIcon from "../assets/Icons/SidebarNew/quotation.svg";
import QuotationWhiteIcon from "../assets/Icons/SidebarNew/quotationWhite.svg";
import OrdersIcon from "../assets/Icons/SidebarNew/orders.svg";
import OrdersWhiteIcon from "../assets/Icons/SidebarNew/ordersWhite.svg";
import EquipmentIcon from "../assets/Icons/SidebarNew/equipment.svg";
import EquipmentWhiteIcon from "../assets/Icons/SidebarNew/equipmentWhite.svg";
import CameraToCloudIcon from "../assets/Icons/SidebarNew/camera.svg";
import CameraToCloudWhiteIcon from "../assets/Icons/SidebarNew/cameraWhite.svg";
import WebsiteIcon from "../assets/Icons/SidebarNew/website.svg";
import WebsiteWhiteIcon from "../assets/Icons/SidebarNew/websiteWhite.svg";
import WhatsAppIcon from "../assets/Icons/SidebarNew/whatsapp.svg";
import WhatsAppWhiteIcon from "../assets/Icons/SidebarNew/whatsappWhite.svg";
import LeadsIcon from "../assets/Icons/SidebarNew/leads.svg";
import LeadsWhiteIcon from "../assets/Icons/SidebarNew/leadsWhite.svg";
import MarketplaceIcon from "../assets/Icons/SidebarNew/marketplace.svg";
import MarketplaceWhiteIcon from "../assets/Icons/SidebarNew/marketplaceWhite.svg";
import RoleIcon from "../assets/Icons/SidebarNew/role.svg";
import RoleWhiteIcon from "../assets/Icons/SidebarNew/roleWhite.svg";

export type SidebarOption = {
  key: string;
  flag: string;
  icon: string;
  whiteIcon: string;
  redirection: string;
  permission?: string;
  anyPermission?: string[];
  module?: string;
  anyModule?: string[];
  children?: SidebarOption[];
};

export const getEffectiveSidebarOption = (
  opt: SidebarOption,
  hasPermission: (perm: string) => boolean,
  hasModule: (mod: string) => boolean,
  isStudioOwner: boolean
): SidebarOption => {
  if (opt.key === "Orders") {
    if (isStudioOwner) return opt;

    const hasOrderAccess =
      hasPermission("orders.read") ||
      hasModule("ORDERS");

    const hasInvoiceAccess =
      hasPermission("invoice.read") ||
      hasPermission("payments_management.read") ||
      hasModule("INVOICE");

    // Case 1: ONLY Invoice permission is given (no Order access)
    if (!hasOrderAccess && hasInvoiceAccess) {
      return {
        ...opt,
        key: "Invoice",
        redirection: "/dashboard/invoice",
        children: opt.children?.filter(
          (c) => c.module === "INVOICE" || c.key.toLowerCase().includes("invoice")
        ),
      };
    }

    // Case 2: ONLY Order permission is given (no Invoice access)
    if (hasOrderAccess && !hasInvoiceAccess) {
      return {
        ...opt,
        children: opt.children?.filter(
          (c) => c.module !== "INVOICE" && !c.key.toLowerCase().includes("invoice")
        ),
      };
    }
  }

  return opt;
};

export const sidebarOptions: SidebarOption[] = [
  {
    key: "Dashboard",
    flag: "Dashboard",
    icon: DashboardIcon,
    whiteIcon: DashboardWhite,
    redirection: "/dashboard/",
    permission: "dashboard.view",
    module: "DASHBOARD",
  },
  {
    key: "Subscriptions",
    flag: "SubScriptions",
    icon: Subscription,
    whiteIcon: SubscriptionWhite,
    redirection: "/dashboard/subscriptions",
    permission: "subscriptions.read",
    module: "SUBSCRIPTIONS",
  },
  {
    key: "Albums",
    flag: "Albums",
    icon: Album,
    whiteIcon: AlbumWhite,
    redirection: "/dashboard/albums/all",
    permission: "albums.view",
    module: "ALBUMS",
  },
  {
    key: "Members",
    flag: "Members",
    icon: Member,
    whiteIcon: MemberWhite,
    redirection: "/dashboard/members/all",
    permission: "members.read",
    module: "MEMBERS",
  },
  {
    key: "Roles & Access",
    flag: "RoleManagement",
    icon: RoleIcon,
    whiteIcon: RoleWhiteIcon,
    redirection: "/dashboard/roles",
    permission: "role_management.read",
    module: "ROLE_MANAGEMENT",
  },
  {
    key: "Events",
    flag: "Events",
    icon: Calander,
    whiteIcon: CalenderWhite,
    redirection: "/dashboard/event",
    permission: "events.read",
    module: "EVENTS",
    children: [
      {
        key: "Event Scheduling",
        flag: "CalendarEvent",
        icon: Calander,
        whiteIcon: CalenderWhite,
        redirection: "/dashboard/event",
        permission: "events.read",
        module: "EVENTS",
      },
      {
        key: "Event Inquiries",
        flag: "UserEvent",
        icon: CustomerEvent,
        whiteIcon: CustomerEventWhite,
        redirection: "/dashboard/events/userCreated",
        permission: "events.read",
        module: "EVENTS",
      },
    ],
  },
  {
    key: "Payments Management",
    flag: "CustomerPaymentFlag",
    icon: Transaction,
    whiteIcon: TransactionWhite,
    redirection: "/dashboard/payments",
    permission: "payments_management.read",
    module: "PAYMENTS_MANAGEMENT",
  },
  {
    key: "Packages",
    flag: "Package",
    icon: PackagePNG,
    whiteIcon: PackageWhite,
    redirection: "/dashboard/packages/all",
    permission: "packages.read",
    module: "PACKAGES",
    children: [
      {
        key: "My Packages",
        flag: "Package",
        icon: PackagePNG,
        whiteIcon: PackageWhite,
        redirection: "/dashboard/packages/all",
        permission: "packages.read",
        module: "PACKAGES",
      },
      {
        key: "Packages Request",
        flag: "Package",
        icon: Packagerequest,
        whiteIcon: PackagerequestWhite,
        redirection: "/dashboard/packages/request",
        permission: "packages.read",
        module: "PACKAGES",
      },
      {
        key: "Booked Packages",
        flag: "Package",
        icon: Transaction,
        whiteIcon: TransactionWhite,
        redirection: "/dashboard/user/transactions",
        permission: "packages.read",
        module: "PACKAGES",
      },
    ],
  },
  {
    key: "Wallet Management",
    flag: "WalletManagement",
    icon: Transaction,
    whiteIcon: TransactionWhite,
    redirection: "/dashboard/whatsapp/billing",
  },
  // {
  //   key: "Analytics",
  //   flag: "Dashboard",
  //   icon: Analytics,
  //   whiteIcon: AnalyticsWhite,
  //   redirection: "/dashboard/analytics",
  // },
  {
    key: "Quotation",
    flag: "Quotation",
    icon: QuotationIcon,
    whiteIcon: QuotationWhiteIcon,
    redirection: "/dashboard/quotation/",
    permission: "quotation.read",
    module: "QUOTATION",
    children: [
      {
        key: "Dashboard",
        flag: "Quotation",
        icon: Analytics,
        whiteIcon: AnalyticsWhite,
        redirection: "/dashboard/quotation/analytics",
        permission: "quotation.read",
        module: "QUOTATION",
      },
      {
        key: "Quotations",
        flag: "Quotation",
        icon: QuotationIcon,
        whiteIcon: QuotationWhiteIcon,
        redirection: "/dashboard/quotation/",
        permission: "quotation.read",
        module: "QUOTATION",
      },
      {
        key: "Products",
        flag: "Quotation",
        icon: QuotationIcon,
        whiteIcon: QuotationWhiteIcon,
        redirection: "/dashboard/quotation/products",
        permission: "quotation.read",
        module: "QUOTATION",
      },
      {
        key: "Fix Charges",
        flag: "Quotation",
        icon: QuotationIcon,
        whiteIcon: QuotationWhiteIcon,
        redirection: "/dashboard/quotation/fix-charges",
        permission: "quotation.read",
        module: "QUOTATION",
      },
      {
        key: "Event Types",
        flag: "Quotation",
        icon: QuotationIcon,
        whiteIcon: QuotationWhiteIcon,
        redirection: "/dashboard/quotation/event-types",
        permission: "quotation.read",
        module: "QUOTATION",
      },
      {
        key: "Album Types",
        flag: "Quotation",
        icon: QuotationIcon,
        whiteIcon: QuotationWhiteIcon,
        redirection: "/dashboard/quotation/album-types",
        permission: "quotation.read",
        module: "QUOTATION",
      },
      {
        key: "Album Papers",
        flag: "Quotation",
        icon: QuotationIcon,
        whiteIcon: QuotationWhiteIcon,
        redirection: "/dashboard/quotation/album-papers",
        permission: "quotation.read",
        module: "QUOTATION",
      },
    ],
  },
  {
    key: "Orders",
    flag: "Orders",
    icon: OrdersIcon,
    whiteIcon: OrdersWhiteIcon,
    redirection: "/dashboard/orders/",
    permission: "orders.read",
    anyPermission: ["orders.read", "invoice.read", "payments_management.read"],
    module: "ORDERS",
    anyModule: ["ORDERS", "INVOICE", "PAYMENTS_MANAGEMENT"],
    children: [
      {
        key: "All Orders",
        flag: "Orders",
        icon: OrdersIcon,
        whiteIcon: OrdersWhiteIcon,
        redirection: "/dashboard/orders/all",
        permission: "orders.read",
        module: "ORDERS",
      },
      {
        key: "Order Work",
        flag: "Orders",
        icon: OrdersIcon,
        whiteIcon: OrdersWhiteIcon,
        redirection: "/dashboard/orders/work",
        permission: "orders.read",
        module: "ORDERS",
      },
      {
        key: "Transactions",
        flag: "Orders",
        icon: OrdersIcon,
        whiteIcon: OrdersWhiteIcon,
        redirection: "/dashboard/orders/transactions",
        permission: "orders.read",
        module: "ORDERS",
      },
      {
        key: "Invoice Dashboard",
        flag: "Dashboard",
        icon: OrdersIcon,
        whiteIcon: OrdersWhiteIcon,
        redirection: "/dashboard/invoice/analytics",
        permission: "invoice.read",
        anyPermission: ["invoice.read", "payments_management.read"],
        module: "INVOICE",
      },
      {
        key: "Invoices",
        flag: "Dashboard",
        icon: OrdersIcon,
        whiteIcon: OrdersWhiteIcon,
        redirection: "/dashboard/invoice",
        permission: "invoice.read",
        anyPermission: ["invoice.read", "payments_management.read"],
        module: "INVOICE",
      },
    ],
  },
  {
    key: "Studio Website",
    flag: "StudioWebsite",
    icon: WebsiteIcon,
    whiteIcon: WebsiteWhiteIcon,
    redirection: "/dashboard/studio-website",
  },
  {
    key: "WhatsApp CRM",
    flag: "WhatsApp",
    icon: WhatsAppIcon,
    whiteIcon: WhatsAppWhiteIcon,
    redirection: "/dashboard/whatsapp",
    permission: "whatsapp_crm.full",
    module: "WHATSAPP_CRM",
  },
  {
    key: "Leads",
    flag: "Leads",
    icon: LeadsIcon,
    whiteIcon: LeadsWhiteIcon,
    redirection: "/dashboard/leads",
    permission: "leads.read",
    module: "LEADS",
  },
  {
    key: "Equipment",
    flag: "Equipment",
    icon: EquipmentIcon,
    whiteIcon: EquipmentWhiteIcon,
    redirection: "/dashboard/equipment",
    permission: "equipment.read",
    module: "EQUIPMENT",
  },
  {
    key: "Camera to Cloud",
    flag: "Dashboard",
    icon: CameraToCloudIcon,
    whiteIcon: CameraToCloudWhiteIcon,
    redirection: "/dashboard/camera-to-cloud",
    permission: "camera_to_cloud.full",
    module: "CAMERA_TO_CLOUD",
  },
  {
    key: "Marketplace",
    flag: "Dashboard",
    icon: MarketplaceIcon,
    whiteIcon: MarketplaceWhiteIcon,
    redirection: "/dashboard/marketplace",
    permission: "marketplace.crud",
    module: "MARKETPLACE",
    children: [
      {
        key: "Overview",
        flag: "Dashboard",
        icon: MarketplaceIcon,
        whiteIcon: MarketplaceWhiteIcon,
        redirection: "/dashboard/marketplace",
      },
      {
        key: "My Listings",
        flag: "Dashboard",
        icon: MarketplaceIcon,
        whiteIcon: MarketplaceWhiteIcon,
        redirection: "/dashboard/marketplace/listings",
      },
      {
        key: "Bookings",
        flag: "Dashboard",
        icon: MarketplaceIcon,
        whiteIcon: MarketplaceWhiteIcon,
        redirection: "/dashboard/marketplace/bookings",
      },
      {
        key: "Requirements",
        flag: "Dashboard",
        icon: MarketplaceIcon,
        whiteIcon: MarketplaceWhiteIcon,
        redirection: "/dashboard/marketplace/requirements",
      },
      {
        key: "My Profile",
        flag: "Dashboard",
        icon: MarketplaceIcon,
        whiteIcon: MarketplaceWhiteIcon,
        redirection: "/dashboard/marketplace/profile",
      },
    ],
  },

];



export interface OptionProps {
  isActive: boolean;
  isExpanded: boolean;
}
